import { useParams } from 'react-router-dom'

const useCampaignIdFromRoute = () => {
  const params: { campaignId?: string } = useParams()
  const campaignId = parseInt(params.campaignId as string, 10)
  return campaignId
}

export { useCampaignIdFromRoute }
